<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ItemList from "@/router/views/procurement/settings-template/item-list";
import UnitList from "@/router/views/procurement/settings-template/unit-list";
import ItemCategory from "@/router/views/procurement/settings-template/item-category";
import ModeOfProcurement from "@/router/views/procurement/settings-template/mode-of-procurement";
import SupplierList from "@/router/views/procurement/settings-template/supplier-list";
import PackageList from "@/router/views/procurement/settings-template/package-list";
import BacSettings from "@/router/views/procurement/settings-template/bac-settings";
import ClientTypes from "@/router/views/procurement/settings-template/client-types";
import EmployeeModal from '@/components/modals/employee.vue';
import PostingFileLabel from "@/router/views/procurement/settings-template/public-posting-label";
import BidActivity from "@/router/views/procurement/settings-template/bid-activity";
import BacActivity from "@/router/views/procurement/settings-template/bac-activity";
import AppTool from "@/router/views/procurement/settings-template/app-tool.vue";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
    page: {
        title: "Procurement Settings",
    },
    components: {
        Layout,
        PageHeader,
        ItemList,
        UnitList,
        ItemCategory,
        ModeOfProcurement,
        SupplierList,
        PackageList,
        BacSettings,
        EmployeeModal,
        ClientTypes,
        PostingFileLabel,
        BidActivity,
        BacActivity,
        PrintOptions,
        AppTool
    },
    data() {
        return {
            title: "Procurement Settings",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Procurement Settings",
                    active: true,
                },
            ],
            tabNo: 0,
            employeeFrom: null
        };
    },
    methods: {
        changeCycle(cycle){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.itemList.changeCycle(cycle, this.$store.state.data.selectedCampus.id);
        },
        changeCampus(campusId){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.bacSettings.getSettings(campusId, true);
            this.$refs.itemList.changeCycle(this.$store.state.data.cycle, campusId);
        },
        getPackages(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.packageList.getPackages();
        },
        getItemCategoryGroup(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.itemCategoryGroup.getItemCategoryGroup();
        },
        getItemCategory(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.itemCategory.getItemCategoryGroup();
            this.$refs.itemCategory.getAccounts();
        },
        getUnits(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.unitList.getUnits();
        },
        getModeOfProcurement(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.modeOfProcurement.getModeOfProcurement();
        },
        getSuppliers(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.supplierList.getSuppliers();
        },
        getBacSettings(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.bacSettings.getSettings(this.$store.state.data.selectedCampus.id);
        },
        getClientTypes(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.clientTypes.getClientType();
        },
        getBidActivity(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.bidAct.getBidActivity();
        },
        getBacActivity(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.bacAct.getBacActivity();
        },
        getAppTool(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.appTool.getAppTool();
        },
        getPFL(){
            this.$store.dispatch('data/mutateGlobalStop', true);
            this.$refs.pfl.getPFL();
        },
        dropEmployeeMultiple(selected){
            if(this.employeeFrom === 'Item Category'){
                this.$refs.itemCategory.saveEmployeeCategories(selected);
            }
        },
        dropSingleEmployee(employee){
            this.$refs.bacSettings.selectedEmployee(employee, this.employeeFrom);
        },
        callEmployeeModal(data){
            this.employeeFrom = data.from;
            if(data.from === 'BAC'){
                this.$refs.empModal.getSingleSelection();
            }else if(data.from === 'Secretary'){
                this.$refs.empModal.getSingleSelection();
            }else{
                this.$refs.empModal.multipleSelection(data.row);
            }
            this.$bvModal.show('employee-modal');
        },
        printCL(){
            this.$refs.printOpt.putOptions({
                apiUrl: 'api/Report/Procurement/Supplier/Report', 
                routeVariables: []
            })
            this.$bvModal.show('print-options-modal')
        }
    },
    beforeRouteLeave (to, from , next) {
        this.$store.dispatch('data/mutateGlobalStop', true);
        next();
    }
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs
            pills
            vertical
            nav-class="p-0 position-sticky"
            nav-wrapper-class="col-sm-2"
            content-class="pt-0 px-2 text-muted"
            v-model="tabNo"
        >
            <b-tab title-item-class="mb-2" @click="changeCycle($store.state.data.cycle)" >
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Items</span>
                </template>
                <item-list ref="itemList"></item-list>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getPackages">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Packages</span>
                </template>
                <package-list ref="packageList"></package-list>
            </b-tab>
            <!-- <b-tab title-item-class="mb-2" @click="getItemCategoryGroup">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Item Category Group</span>
                </template>
                
            </b-tab> -->
            <b-tab title-item-class="mb-2" @click="getItemCategory">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Item Category</span>
                </template>
                <item-category ref="itemCategory" @callToOpen="callEmployeeModal"></item-category>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getUnits">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Units</span>
                </template>
                <unit-list ref="unitList"></unit-list>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getModeOfProcurement">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Mode of Procurement</span
                    >
                </template>
                <mode-of-procurement
                    ref="modeOfProcurement"
                ></mode-of-procurement>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getSuppliers">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Client Master</span>
                </template>
                <supplier-list ref="supplierList" @printCL="printCL"></supplier-list>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getBacSettings">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">BAC Settings</span>
                </template>
                <bac-settings ref="bacSettings" @callToOpen="callEmployeeModal"></bac-settings>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getClientTypes">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Client Types</span>
                </template>
                <client-types ref="clientTypes"></client-types>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getPFL">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Posting File Labels</span>
                </template>
                <posting-file-label ref="pfl"></posting-file-label>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getBidActivity">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Bid Activity</span>
                </template>
                <bid-activity ref="bidAct"></bid-activity>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getBacActivity">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">BAC Activity</span>
                </template>
                <bac-activity ref="bacAct"></bac-activity>
            </b-tab>
            <b-tab title-item-class="mb-2" @click="getAppTool">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Procurement Strategy Tool</span>
                </template>
                <app-tool ref="appTool"></app-tool>
            </b-tab>
        </b-tabs>
        <employee-modal ref="empModal" @dropMultiple="dropEmployeeMultiple" @dropData="dropSingleEmployee"></employee-modal>
        <print-options ref="printOpt"></print-options>
    </Layout>
</template>